/*jslint white: true, nomen: true */
/*global angular, navigator, $, document, window */
/*global ScrollMagic, TweenMax */
(function() {

  'use strict';
  /* global $, angular, ScrollMagic, TweenMax */

  var _mainModules = [
    'angular-inview',
    'ui.bootstrap',
    'ngRoute',
    'ngCookies',
    'Milestone.DataServices',
    'Milestone.Forms',
    'Milestone.Maps',
    'Milestone.Menu',
    'Milestone.HomePage',
    'Milestone.quickStayConnected',
    'Milestone.VelocityJs',
    'Milestone.Slideshow',
    'Milestone.Scrollspy',
    'Milestone.mySavedHomes',
    'Milestone.Popup',
    'ngSanitize',
    'ngTouch',
    'angular-fastclick',
    'ngAnimate',
    'common',
    'LocalStorageModule',
    'ngFileUpload'
  ];

  angular
    .module("Milestone", _mainModules)

  .config(['$interpolateProvider', function($interpolateProvider) {
    $interpolateProvider.startSymbol('<%');
    $interpolateProvider.endSymbol('%>');
  }])

  .config(['localStorageServiceProvider', function (localStorageServiceProvider) {
    localStorageServiceProvider
      .setPrefix('siteApp')
      .setStorageType('sessionStorage')
      .setNotify(true, true)
  }]);



  angular.module("common", [
      'ngSanitize',
      'ngTouch'
  ]);

  angular.module("common")
  .filter('trust', ['$sce', function($sce) {
    return $sce.trustAsHtml;
  }])
  .filter('trustAsResourceUrl', ['$sce', function($sce) {
    return function(val) {
      return $sce.trustAsResourceUrl(val);
    };
  }])
  .filter('embedUrl', function() {
    return function(originalUrl) {
      // youtube
      const regExpYoutube = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      const matchYoutube = originalUrl.match(regExpYoutube);
      if (matchYoutube&&matchYoutube[7].length==11) {
        return 'https://www.youtube.com/embed/' + matchYoutube[7];
      }

      // adds support for all variants of vimeo urls
      const regExpVimeo = /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/;
      const matchVimeo = originalUrl.match(regExpVimeo);
      if (matchVimeo) {
        const parseUrl = originalUrl.split(
          /vimeo.com\/([a-z]+\/)*([0-9]{6,11})/i
        );

        return 'https://player.vimeo.com/video/' + Number(parseUrl[2]);
      }

      // matterport
      return originalUrl;
    }
  });

  angular.module("Milestone.DataServices", []);

  angular.module("Milestone.Slideshow", []);

  angular.module("Milestone.Maps", []);

  angular.module("Milestone.Menu", []);

  angular.module("Milestone.VelocityJs", []);

  angular.module("Milestone.Forms", []);

  angular.module("Milestone.mySavedHomes", [
    'ui.bootstrap',
  ]);

  angular
    .module("Milestone.findYourHome", [
      'Milestone',
      'Milestone.Forms',
      'Milestone.Maps',
      'Milestone.Menu',
      'Milestone.quickStayConnected',
      'Milestone.DataServices',
      'Milestone.VelocityJs',
      'Milestone.Slideshow',
      'Milestone.Scrollspy',
      'ngRoute',
      'angular-inview',
      'ui.bootstrap',
      'ngSanitize',
      'ngTouch',
      'angular-fastclick',
      'ngAnimate',
      'common'
    ])
  ;

  angular
    .module("Milestone.findYourHome")
    .config(['$interpolateProvider', function($interpolateProvider) {
      $interpolateProvider.startSymbol('<%');
      $interpolateProvider.endSymbol('%>');
    }])
    .config(['$routeProvider', '$locationProvider',
      function($routeProvider, $locationProvider) {
        $locationProvider.html5Mode(true);

        $routeProvider
          .when('/find-your-home/map', {
            templateUrl: 'find-your-home/map.html',
            controller: "FindYourHomeMapCtrl"
          })
          .when('/find-your-home/:seoName', {
            templateUrl: 'find-your-home/community-list.html',
            controller: "FindYourHomeCtrl"
          })
          .when('/find-your-home', {
            redirectTo: '/find-your-home/downtown-south-austin'
          })
          .otherwise({
            template: "<div></div>",
            controller: ['$window', '$location', '$rootScope',
              function ($window, $location, $rootScope) {
                $window.location.href = $location.absUrl();
              }
            ]
          })
        ;
      }
    ])
  ;

  angular
    .module("Milestone.quickDeliveryHomes", [
      'Milestone',
      'Milestone.Forms',
      'Milestone.Maps',
      'Milestone.Menu',
      'Milestone.quickStayConnected',
      'Milestone.DataServices',
      'Milestone.VelocityJs',
      'Milestone.Slideshow',
      'Milestone.Scrollspy',
      'ngRoute',
      'angular-inview',
      'ui.bootstrap',
      'ngSanitize',
      'ngTouch',
      'angular-fastclick',
      'ngAnimate',
      'common'
    ])
  ;

  angular
    .module("Milestone.quickDeliveryHomes")
    .config(['$interpolateProvider', function($interpolateProvider) {
      $interpolateProvider.startSymbol('<%');
      $interpolateProvider.endSymbol('%>');
    }])
    .config(['$routeProvider', '$locationProvider',
      function($routeProvider, $locationProvider) {
        $locationProvider.html5Mode(true);

        // $routeProvider
          // .when('/quick-delivery-homes/:seoName', {
          //   templateUrl: 'quick-delivery-homes/quick-delivery-homes.html',
          //   controller: "QuickDeliveryHomesCtrl"
          // })
          // .when('/quick-delivery-homes', {
          //   redirectTo: '/quick-delivery-homes/buda-and-kyle'
          // })
          // .otherwise({
          //   template: "<div></div>",
          //   controller: ['$window', '$location', '$rootScope',
          //     function ($window, $location, $rootScope) {
          //       $window.location.href = $location.absUrl();
          //     }
          //   ]
          // })
        // ;
      }
    ])
  ;

  angular.module("Milestone.Menu")
  .run(['$route', '$rootScope', '$location',
    function($route, $rootScope, $location) {

      //mobile detect
      $rootScope.is_mobile = false;
      $rootScope.is_phone = false;
      $rootScope.is_ipad = /ipad/i.test(navigator.userAgent);
      $rootScope.is_portrait = false;

      $(document).ready($rootScope.checkDevice);
      $(window).resize($rootScope.checkDevice);

      $rootScope.checkDevice = function(){
        /*destect ipad and phone*/
        if($(window).width() < 1025){
          $rootScope.is_mobile = true;
        }
        // detect ipad only
        if($(window).width() > 768 && $(window).width() < 1025){
          $rootScope.is_ipad = true;
        }
        /*detect phone only*/
        if($(window).width() < 768){
          $rootScope.is_phone = true;
        }
        /*detect orientation*/
        if ($(window).width() < $(window).height()) {
          $rootScope.is_portrait = true;
        }
      };

      //relevant to BS Carousel
      $rootScope.hideCarouselTitle = function(inview, inviewpart) {

        if (inviewpart) {
          $(".header").velocity('fadeOut', 200);
        } else {
          $(".header").velocity('fadeIn', 600);
        }
      };

      //update url without refresh
      var original = $location.path;
      $location.path = function(path, reload) {
        if (reload === false) {
          var lastRoute = $route.current,
            un = $rootScope.$on('$locationChangeSuccess', function() {
            $route.current = lastRoute;
            un();
          });
        }
        return original.apply($location, [path]);
      };
    }
  ])
  .service('device', [
    function(){

        this.check = function(){
          var type = "desktop";
          /*detect ipad only*/
          if($(window).width() > 767 && $(window).width() < 1025){
            type =  "ipad";
          }
          /*detect phone only*/
          if($(window).width() < 768){
            type = "phone";
          }
          return type;
        };

        this.orientation = function(){
          var orientation = "landscape";
          if($(window).width() < $(window).height()){
            return "portrait";
          }
          return orientation;
        };

        this.touch = function(){
          var is_touch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          return is_touch;
        }

    }
  ])

  .service('scrollMagic', [
    function() {
      var controller = new ScrollMagic.Controller();

      function toggleClass(e,target,className){
          if (e === "enter") {
            $(target).addClass(className);
          }

          if (e === "leave") {
            $(target).removeClass(className);
          }
      }

      this.parallax = function(elem, target) {
        target = $(elem).find(target);
        var tween = TweenMax.to(target, 100, {
          top: -100,
          scale: 1
        });

        new ScrollMagic.Scene({
          triggerElement: elem,
          duration: "200%"
        })
        .setTween(tween)
        //.addIndicators()
        .addTo(controller);
      };

      this.scrollTrigger = function(elem, target, className) {

        new ScrollMagic.Scene({
          triggerElement: elem,
          duration: "200%"
        })
          .on('enter leave', function(e) {
            toggleClass(e.type, target, className);
          })
          //.addIndicators()
          .addTo(controller);
      };

      this.affix = function(elem, target, className) {
        new ScrollMagic.Scene({triggerElement: elem})
          .triggerHook("onLeave")
          .on('enter leave', function(e) {
            toggleClass(e.type, target, className);
          })
          //.addIndicators()
          .addTo(controller);

      };

      this.header = function(elem, target) {
        target = $(elem).find(target);
        var tween = TweenMax.to(target, 1, {
          scale: 0.9
        });

        new ScrollMagic.Scene({
          triggerElement: elem,
          duration: 200,
          offset: -50
        })
          .setTween(tween)
        //.addIndicators()
        .addTo(controller);
      };

      this.cardStack = function(elem, className, offset, navHeight) {

        var zIndex = 0;
        if (className === 'absolute') {
          zIndex = 1;
          navHeight = 0;
        }

        new ScrollMagic.Scene({
          triggerElement: elem,
          offset: offset
        })
          .on('enter leave', function(e) {
            var $innerElem = $(elem).find('.innerCardStack');
            //set innerDiv to fixed
            if (e.type === "enter") {
              $innerElem.addClass(className).css('top', navHeight);
            }
            //reset previous innerDiv back to normal
            if (e.type === "leave") {
              $innerElem.removeClass(className).css('top', 0);
            }
          })
        //.addIndicators(elem)
        .addTo(controller);
      };
    }
  ])


}());


/**
 * Polyfill for requestAnimationFrame
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 * MIT license
 */
(function() {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
      || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }
  if(!window.requestAnimationFrame)
    window.requestAnimationFrame = function(callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function() {
          callback(currTime + timeToCall);
        },
        timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  if(!window.cancelAnimationFrame)
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id);
    };
}());

var UnitTestSuite = false;

function assert(condition, message) {
  'use strict';
  if ( ! UnitTestSuite) {
    return;
  }

  if (!condition) {
    throw message || "Assertion failed";
  }
}

assert(UnitTestSuite, 'Testing Disabled');
